__turbopack_context__.v({
  "accordion": "Accordion-module__uF9gGa__accordion",
  "accordion__content": "Accordion-module__uF9gGa__accordion__content",
  "accordion__icon": "Accordion-module__uF9gGa__accordion__icon",
  "accordion__section": "Accordion-module__uF9gGa__accordion__section",
  "accordion__text": "Accordion-module__uF9gGa__accordion__text",
  "accordion__title": "Accordion-module__uF9gGa__accordion__title",
  "active": "Accordion-module__uF9gGa__active",
  "rotate": "Accordion-module__uF9gGa__rotate",
});
